import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfirmationService, ConfirmationData } from './confirmation.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirmation-modal',
  imports: [CommonModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: true,
})
export class ConfirmationModalComponent implements OnInit, OnDestroy {
  visible = false;
  animateOut = false;
  mensaje = '';
  imagen?: string;
  tipo: 'success' | 'error' | 'info' | 'warning' = 'warning';

  private resolveFn: ((result: boolean) => void) | null = null;

  constructor(private confirmationService: ConfirmationService) {}

  ngOnInit() {
    console.log('ConfirmationModalComponent inicializado');

    this.confirmationService.confirmation$.subscribe(
      (data: ConfirmationData) => {
        this.mensaje = data.mensaje;
        this.imagen = data.imagen;
        this.tipo = data.tipo || 'warning';
        this.visible = true;
        this.animateOut = false;

        // Usamos una promesa interna para devolver el resultado
        this.resolveFn = null;
        const promise = new Promise<boolean>((resolve) => {
          this.resolveFn = resolve;
        });

        // Enviamos la promesa al servicio para que el que llamó pueda esperar
        this.confirmationService.setPromise(promise);
      },
    );
  }

  onConfirm() {
    this.closeModal(true);
  }

  onCancel() {
    this.closeModal(false);
  }

  onBackdropClick(event: MouseEvent) {
    // Opcional: cerrar al hacer clic fuera (puedes desactivarlo si no quieres)
    if (
      (event.target as HTMLElement).classList.contains('confirmation-modal')
    ) {
      this.closeModal(false);
    }
  }

  private closeModal(confirmed: boolean) {
    this.animateOut = true;
    setTimeout(() => {
      this.visible = false;
      if (this.resolveFn) {
        this.resolveFn(confirmed); // ✅ Ahora TS sabe que no es null gracias al if
        this.resolveFn = null; // ✅ Reset para evitar reusos
      }
    }, 500);
  }

  ngOnDestroy() {
    // Si el modal se destruye sin respuesta, resolvemos con false
    if (this.resolveFn) {
      this.resolveFn(false);
      this.resolveFn = null;
    }
  }
}
